type Handler = (...args: unknown[]) => void;

class Bus {
  private listeners = new Map<string, Set<Handler>>();

  on(event: string, handler: Handler): () => void {
    let set = this.listeners.get(event);
    if (!set) {
      set = new Set();
      this.listeners.set(event, set);
    }
    set.add(handler);
    return () => this.off(event, handler);
  }

  off(event: string, handler: Handler): void {
    this.listeners.get(event)?.delete(handler);
  }

  emit(event: string, ...args: unknown[]): void {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const handler of [...set]) {
      handler(...args);
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}

/** Shared React ↔ Phaser bridge for Nganya. */
export const EventBus = new Bus();

export const Events = {
  HUD: 'mm:hud',
  GAME_OVER: 'mm:gameover',
  PAUSE: 'mm:pause',
  RESUME: 'mm:resume',
  REQUEST_PAUSE: 'mm:request-pause',
  REQUEST_RESUME: 'mm:request-resume',
  REQUEST_RESTART: 'mm:request-restart',
  REQUEST_MENU: 'mm:request-menu',
  LANE_LEFT: 'mm:lane-left',
  LANE_RIGHT: 'mm:lane-right',
  BOOST: 'mm:boost',
  READY: 'mm:ready',
  POPUP: 'mm:popup',
} as const;
